<template>
  <div class="main">
    <c-panel title="Classificações (CDD, CDU e Classe)" titleIcon="fas fa-sitemap">
      <!--
        Item 1: CDD, CDU e Classe "conforme tipo de classificação, possibilitando a escolha
        de uso de uma destas classificações". A escolha é parâmetro da rede — abaixo.
      -->
      <el-alert v-if="padrao" type="info" :closable="false" show-icon class="u-mb-15"
                :title="'Classificação em uso na rede: ' + rotuloPadrao">
        <span class="u-fs-12">
          As demais continuam disponíveis no cadastro do material — mudar a escolha não apaga
          o que já foi catalogado.
        </span>
      </el-alert>

      <el-row :gutter="10" class="u-mb-15" v-if="podeDefinir">
        <el-col :xs="24" :sm="10">
          <el-select v-model="novoPadrao" placeholder="Classificação em uso" style="width:100%">
            <el-option v-for="o in tipos" :key="o.valor" :label="o.rotulo" :value="o.valor"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-button type="warning" plain @click="definirPadrao" :disabled="!novoPadrao || novoPadrao === padrao">
            DEFINIR EM USO
          </el-button>
        </el-col>
      </el-row>

      <catalogo-crud tipo="classificacao" rotuloNovo="NOVA CLASSIFICAÇÃO" nomeSingular="classificação"
                     placeholderBusca="Pesquisar por código ou descrição"
                     :campos="campos" :colunas="colunas" :filtroExtra="filtroExtra"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

const TIPOS = [
  { valor: 'cdd', rotulo: 'CDD — Classificação Decimal de Dewey' },
  { valor: 'cdu', rotulo: 'CDU — Classificação Decimal Universal' },
  { valor: 'classe', rotulo: 'Classe' }
]

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    tipos: TIPOS,
    padrao: '',
    novoPadrao: '',
    campos: [
      { chave: 'tipo', label: 'Tipo', tipo: 'select', obrigatorio: true, opcoes: TIPOS, span: 24 },
      { chave: 'codigo', label: 'Código', obrigatorio: true, span: 8, max: 40 },
      { chave: 'descricao', label: 'Descrição', obrigatorio: true, span: 16, max: 191 }
    ],
    colunas: [
      { chave: 'tipo', label: 'Tipo', largura: '90px', mapa: { cdd: 'CDD', cdu: 'CDU', classe: 'Classe' } },
      { chave: 'codigo', label: 'Código', largura: '120px' },
      { chave: 'descricao', label: 'Descrição' }
    ],
    filtroExtra: { chave: 'tipo_classificacao', label: 'Tipo', opcoes: TIPOS }
  }),
  computed: {
    podeDefinir () { return [4, 5, 7].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    rotuloPadrao () {
      const t = TIPOS.filter(x => x.valor === this.padrao)[0]
      return t ? t.rotulo : this.padrao
    }
  },
  mounted () { this.carregarPadrao() },
  methods: {
    carregarPadrao () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/biblioteca/catalogo/listas`,
                      this.$store.getters.getHeaderAuth)
        .then(r => {
          if (!r.data || r.data.erro) return
          this.padrao = r.data.classificacao_padrao
          this.novoPadrao = this.padrao
        }).catch(() => {})
    },
    definirPadrao () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/catalogo/classificacao-padrao`,
                       { valor: this.novoPadrao }, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) {
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }
          this.padrao = this.novoPadrao
          window.eventBus.$emit('alert', { msg: 'Classificação em uso definida.', type: 'success' })
        }).catch(e => this.$store.commit('throwException', e))
    }
  }
}
</script>
